import { Stack } from '@mui/material'
import { Typography } from '@evocolabs/orkaui'
import styled from '@mui/styles/styled'
import { useRouter } from 'next/router'
import ImageCard from '../ImageCard'
import theme from '@/src/theme'
import joinCDN from '@/src/utils/CDN'
import { Blog } from '@/src/types/blog'

export interface BlogCardProps
  extends Pick<Blog, 'title' | 'subtitle' | 'pic' | 'theme' | 'url_postfix' | 'spend_time' | 'write_time'> {}

const Tag = styled('div')({
  padding: '4px 8px',
  backgroundColor: theme.palette.primary[100],
  width: 'fit-content',
  borderRadius: '4px'
})

export function capitalizeWords(input: string): string {
  return input
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export const BlogCard = ({ item }: { item: BlogCardProps }) => {
  const { title, subtitle, pic, spend_time: spendTime, write_time: writeTime, theme: tag, url_postfix: url } = item
  const { primary, grey } = theme.palette
  const router = useRouter()

  return (
    <ImageCard
      src={joinCDN(`imgs/blog/shareImgs/${pic}`, 'CA')}
      title={title}
      spacing={2}
      onClick={() => {
        router.push(`/blogPage/${url}`)
      }}
    >
      <Stack gap={1}>
        <Tag>
          <Typography variant="Body3" color={primary[600]}>
            {capitalizeWords(tag)}
          </Typography>
        </Tag>
        <Typography variant="title1" color={grey[800]} dangerouslySetInnerHTML={{ __html: title }}></Typography>
        <Typography variant="body2" color={grey[700]} dangerouslySetInnerHTML={{ __html: subtitle }}></Typography>
        <Typography variant="body3" color={grey[500]}>
          {writeTime} - {spendTime} min read
        </Typography>
      </Stack>
    </ImageCard>
  )
}

export default BlogCard
